const javaVersions = [
  {
    version: "8",
    blogPost: "",
    date: "2014-03-18",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Lambda Expressions and Default Methods",
          blog_post: "",
          jep_numbers: "JEP-126",
          description: "Introduced functional programming constructs and virtual extension methods to interfaces, enabling more concise code and stream processing."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Nashorn JavaScript Engine ",
          blog_post: "",
          jep_numbers: "JEP-174",
          description: "Added a new high-performance JavaScript engine written in Java to replace Rhino."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Stream API",
          blog_post: "",
          jep_numbers: "JEP-107",
          description: "Provided java.util.stream for declarative collection processing (e.g., filter/map/reduce)."
        }
      },
      {
        id: 4,
        metadata: {
          feature_name: "Date and Time API",
          blog_post: "",
          jep_numbers: "JSR-310",
          description: "Delivered the new java.time package for more robust date/time handling."
        }
      }
    ]
  }, {
    version: "9",
    blogPost: "",
    date: "2015-03-20",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Java Platform Module System",
          blog_post: "",
          jep_numbers: "JEP-261",
          description: "Implemented modularization (Project Jigsaw), modularized the JDK, and enabled creation of scalable, secure applications."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "JShell: Read-Eval-Print Loop",
          blog_post: "",
          jep_numbers: "JEP-222",
          description: "Added an interactive REPL for quickly evaluating Java code without full class definitions."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Factory Methods for Collections",
          blog_post: "",
          jep_numbers: "JEP-269",
          description: "Introduced static factory methods like List.of(...) and Set.of(...) for creating immutable collections succinctly."
        }
      },
      {
        id: 4,
        metadata: {
          feature_name: "Compact Strings",
          blog_post: "",
          jep_numbers: "JEP-269",
          description: "Introduced static factory methods like List.of(...) and Set.of(...) for creating immutable collections succinctly."
        }
      },
    ]
  },
  {
    version: "10",
    blogPost: "",
    date: "2016-03-25",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Local-Variable Type Inference ",
          blog_post: "",
          jep_numbers: "JEP-286",
          description: "Introduced the var keyword to allow the compiler to infer local variable types, improving readability."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Application Class-Data Sharing",
          blog_post: "",
          jep_numbers: "JEP-310",
          description: "Enabled pre-processing application classes into a shared archive to reduce startup time and memory footprint."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Parallel Full GC for G1",
          blog_post: "",
          jep_numbers: "JEP-307",
          description: "Enhanced the G1 garbage collector with parallel full-garbage-collection support to reduce pause times."
        }
      }
    ]
  },
   {
    version: "11",
    blogPost: "",
    date: "2018-09-25",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "HTTP Client",
          blog_post: "",
          jep_numbers: "JEP-321",
          description: "Promoted the HTTP Client API to standard, supporting HTTP/2 and WebSocket, replacing the legacy HttpURLConnection."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Launch Single-File Source-Code Programs",
          blog_post: "",
          jep_numbers: "JEP-330",
          description: "Allowed execution of Java source files directly without explicit compilation, simplifying scripting."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Z Garbage Collector ",
          blog_post: "",
          jep_numbers: "JEP-333",
          description: "Introduced a scalable, low-latency GC, suitable for applications requiring large heaps and predictable pauses."
        }
      },
      {
        id: 4,
        metadata: {
          feature_name: "Deprecate the Nashorn JavaScript Engine",
          blog_post: "",
          jep_numbers: "JEP-335",
          description: "Marked Nashorn for removal due to maintenance concerns, steering users toward external JS engines."
        }
      }
    ]
  },
   {
    version: "12",
    blogPost: "",
    date: "2019-03-19",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Switch Expressions (Preview)",
          blog_post: "",
          jep_numbers: "JEP-325",
          description: "Extended the switch statement to be an expression and introduced the case L -> syntax for more concise code."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Shenandoah: Low-Pause-Time Garbage Collector (Experimental)",
          blog_post: "",
          jep_numbers: "JEP-189",
          description: "Introduced an experimental GC that performs evacuation work concurrently with Java threads to reduce pause times."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "JVM Constants API ",
          blog_post: "",
          jep_numbers: "JEP-334",
          description: "Provided an API to model nominal descriptions of key class-file and run-time artifacts, improving tooling and reflection. "
        }
      }
    ]
  },
   {
    version: "13",
    blogPost: "",
    date: "2019-09-17",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Text Blocks (Preview)",
          blog_post: "",
          jep_numbers: "JEP-355",
          description: "Added multi-line string literals to simplify embedding JSON, SQL, HTML, etc., without escape clutter."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Dynamic CDS Archives",
          blog_post: "",
          jep_numbers: "JEP-350",
          description: "Enabled dynamic creation of shared class-data archives at application exit, improving future startups."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "ZGC: Uncommit Unused Memory",
          blog_post: "",
          jep_numbers: "JEP-351",
          description: "Allowed the ZGC to return unused Java heap memory to the operating system."
        }
      }
    ]
  },
  {
    version: "14",
    blogPost: "",
    date: "2020-03-17",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Records (Preview)",
          blog_post: "",
          jep_numbers: "JEP-359",
          description: "Introduced a compact syntax for declaring classes that act as transparent carriers for immutable data."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Pattern Matching for instanceof (Preview)",
          blog_post: "",
          jep_numbers: "JEP-305",
          description: "Combined instanceof checks and casts into a single pattern matching operation for less boilerplate."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Helpful NullPointerExceptions",
          blog_post: "",
          jep_numbers: "JEP-358",
          description: "Enhanced the JVM to provide detailed messages when a NullPointerException occurs, aiding debugging."
        }
      }
    ]
  },
  {
    version: "15",
    blogPost: "",
    date: "2020-09-15",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Text Blocks",
          blog_post: "",
          jep_numbers: "JEP-378",
          description: "Finalized text blocks, simplifying multi-line string literals without need for escape sequences."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Hidden Classes",
          blog_post: "",
          jep_numbers: "JEP-371",
          description: "Introduced classes that cannot be discovered by name, enabling frameworks and dynamic languages to generate classes without polluting namespaces."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Sealed Classes (Preview)",
          blog_post: "",
          jep_numbers: "JEP-360",
          description: "Allowed classes and interfaces to control which other classes or interfaces may extend or implement them, providing stronger encapsulation. "
        }
      }
    ]
  },
    {
    version: "16",
    blogPost: "",
    date: "2021-03-21",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Records",
          blog_post: "",
          jep_numbers: "JEP-395",
          description: " Finalized records, enabling concise data carriers with built-in equals(), hashCode(), and toString()."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Pattern Matching for instanceof",
          blog_post: "",
          jep_numbers: "JEP-394",
          description: "Finalized pattern matching in instanceof, reducing boilerplate in type checks."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Strongly Encapsulate JDK Internals",
          blog_post: "",
          jep_numbers: "JEP-396",
          description: "Migrated the JDK to fully encapsulate internal elements (except critical APIs), improving security and maintainability."
        }
      }
    ]
  },
    {
    version: "17",
    blogPost: "",
    date: "2021-09-14",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Sealed Classes",
          blog_post: "",
          jep_numbers: "JEP-409",
          description: "Finalized sealed classes, restricting class hierarchies to a specified set of permitted subclasses."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Pattern Matching for switch (Preview)",
          blog_post: "",
          jep_numbers: "JEP-406",
          description: "Introduced pattern matching in switch, allowing cases to be selected based on type patterns and guards."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Foreign Function & Memory API (Incubator)",
          blog_post: "",
          jep_numbers: "JEP-412",
          description: "Provided an API for native code and memory access, intended to replace JNI."
        }
      },
      {
        id: 4,
        metadata: {
          feature_name: "FEnhanced Pseudo-Random Number Generators",
          blog_post: "",
          jep_numbers: "JEP-356",
          description: "Added new interfaces and implementations for pseudo-random number generation, improving flexibility and performance."
        }
      }
    ]
  },
  {
    version: "18",
    blogPost: "",
    date: "2022-03-22",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "UTF-8 by Default",
          blog_post: "",
          jep_numbers: "JEP-400",
          description: "Standardized UTF-8 as the default charset, enhancing portability and consistency across environments."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Simple Web Server (Incubator)",
          blog_post: "",
          jep_numbers: "JEP-408",
          description: "Added a command-line tool to serve static files over HTTP for quick prototyping."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Vector API (Incubator)",
          blog_post: "",
          jep_numbers: "JEP-417",
          description: "Extended the Vector API to the jdk.incubator.vector package, enabling explicit SIMD operations for performance."
        }
      }
    ]
  },
  {
    version: "19",
    blogPost: "",
    date: "2022-09-20",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Virtual Threads (Preview)",
          blog_post: "",
          jep_numbers: "JEP-425",
          description: "Introduced lightweight threads (Project Loom) to simplify writing, maintaining, and observing high-throughput concurrent code."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Structured Concurrency (Incubator)",
          blog_post: "",
          jep_numbers: "JEP-428",
          description: "Treated multiple tasks running in different threads as a single unit of work, simplifying multithreaded code."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Record Patterns (Preview)",
          blog_post: "",
          jep_numbers: "JEP-405",
          description: "Extended pattern matching to deconstruct record values, making data-oriented code more concise."
        }
      }
    ]
  },
  {
    version: "20",
    blogPost: "",
    date: "2023-03-21",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Scoped Values (Incubator)",
          blog_post: "",
          jep_numbers: "JEP-429",
          description: "Provided an alternative to thread-local variables for sharing immutable data within and across threads in a scoped fashion."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Pattern Matching for switch (Preview)",
          blog_post: "",
          jep_numbers: "JEP-433",
          description: "2nd Preview. Improved upon the initial preview, refining exhaustiveness checking and expressiveness."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Virtual Threads (Preview)",
          blog_post: "",
          jep_numbers: "JEP-436",
          description: "2nd Preview. Refined virtual threads for better performance and observability."
        }
      }
    ]
  },
  {
    version: "21",
    blogPost: "",
    date: "2023-09-19",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Virtual Threads",
          blog_post: "",
          jep_numbers: "JEP-444",
          description: "Finalized virtual threads, drastically reducing the effort required to write scalable concurrent applications."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Record Patterns",
          blog_post: "",
          jep_numbers: "JEP-440",
          description: "Finalized record patterns, enabling nested pattern matching for records."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Pattern Matching for switch",
          blog_post: "",
          jep_numbers: "JEP-447",
          description: "Finalized pattern matching in switch, eliminating verbosity."
        }
      }
    ]
  },
  {
    version: "22",
    blogPost: "",
    date: "2024-03-19",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Unnamed Classes & Instance Main Methods",
          blog_post: "",
          jep_numbers: "JEP-456",
          description: "Introduced a simplified way to launch Java code without defining a named class or a public static void main signature."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Foreign Function & Memory API  (Incubator)",
          blog_post: "",
          jep_numbers: "JEP-444",
          description: "3rd Incubator. Refined the API for safer, more efficient native code and memory interactions."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Stream Gatherers (Preview)",
          blog_post: "",
          jep_numbers: "JEP-461",
          description: "Added a mechanism to collect and reorder stream elements more flexibly, enriching the Stream API."
        }
      }
    ]
  },
  {
    version: "23",
    blogPost: "",
    date: "2024-09-17",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "String Templates (Preview)",
          blog_post: "",
          jep_numbers: "JEP-430",
          description: "Introduced string templates to allow embedding expressions directly in string literals; later removed due to design changes."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Record Patterns (Preview)",
          blog_post: "",
          jep_numbers: "JEP-434",
          description: "3rd Preview. Further refined record patterns, improving exhaustiveness and expressiveness. "
        }
      }
    ]
  },
      {
    version: "24",
    blogPost: "",
    date: "2025-03-18",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Class-File API",
          blog_post: "",
          jep_numbers: "JEP-484",
          description: "Provided a standard API for parsing, generating, and transforming Java class files, facilitating tool compatibility and evolution."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Compact Object Headers",
          blog_post: "",
          jep_numbers: "JEP-450",
          description: "Part of Project Lilliput, shrank object headers from 96-128 bits to 64 bits, reducing memory overhead by up to 20%."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Stream Gatherers",
          blog_post: "",
          jep_numbers: "JEP-485",
          description: "Graduated from preview to standard, offering richer collection mechanisms for Java Streams."
        }
      },
      {
        id: 4,
        metadata: {
          feature_name: "Scoped Values (Preview)",
          blog_post: "",
          jep_numbers: "JEP-387",
          description: "4th Preview. Continued evolution of scoped values, enabling safer sharing of immutable data across threads."
        }
      },
      {
        id: 5,
        metadata: {
          feature_name: "Vector API (Incubator)",
          blog_post: "",
          jep_numbers: "JEP-489",
          description: "9th Incubator. Further advanced the Vector API, adding new vector operations for high-performance computing."
        }
      }
    ]
  },
  {
    version: "25",
    blogPost: "",
    date: "2025-09-16",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "Scoped Values",
          blog_post: "",
          jep_numbers: "JEP-506",
          description: "Finalized scoped values, enabling safer sharing of immutable data within and across threads without relying on thread-local variables."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Compact Source Files and Instance Main Methods",
          blog_post: "",
          jep_numbers: "JEP-512",
          description: "Simplified small Java programs by allowing compact source files and instance main methods, reducing ceremony for beginners and scripts."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "Compact Object Headers",
          blog_post: "",
          jep_numbers: "JEP-519",
          description: "Reduced object header size to lower memory footprint and improve density for many Java workloads."
        }
      },
      {
        id: 4,
        metadata: {
          feature_name: "Flexible Constructor Bodies",
          blog_post: "",
          jep_numbers: "JEP-513",
          description: "Allowed more flexible code before explicit constructor invocation, making constructor validation and setup easier to express."
        }
      },
      {
        id: 5,
        metadata: {
          feature_name: "Generational Shenandoah",
          blog_post: "",
          jep_numbers: "JEP-521",
          description: "Introduced a generational mode for the Shenandoah garbage collector to improve throughput and memory management for many applications."
        }
      }
    ]
  },
  {
    version: "26",
    blogPost: "",
    date: "2026-03-17",
    features: [
      {
        id: 1,
        metadata: {
          feature_name: "HTTP/3 Support for the HTTP Client API",
          blog_post: "",
          jep_numbers: "JEP-517",
          description: "Added HTTP/3 support to Java's built-in HTTP Client API, enabling modern QUIC-based networking while keeping the familiar client model."
        }
      },
      {
        id: 2,
        metadata: {
          feature_name: "Ahead-of-Time Object Caching with Any GC",
          blog_post: "",
          jep_numbers: "JEP-516",
          description: "Extended ahead-of-time startup improvements by enabling object caching to work with any garbage collector."
        }
      },
      {
        id: 3,
        metadata: {
          feature_name: "G1 GC Throughput Improvements",
          blog_post: "",
          jep_numbers: "JEP-522",
          description: "Improved G1 garbage collector throughput, helping common server workloads run more efficiently."
        }
      },
      {
        id: 4,
        metadata: {
          feature_name: "Structured Concurrency (Preview)",
          blog_post: "",
          jep_numbers: "JEP-525",
          description: "Continued the preview of structured concurrency, treating related concurrent tasks as a single unit of work for clearer cancellation and error handling."
        }
      },
      {
        id: 5,
        metadata: {
          feature_name: "Vector API (Incubator)",
          blog_post: "",
          jep_numbers: "JEP-529",
          description: "Continued incubation of the Vector API for expressing SIMD computations that can compile to optimal hardware vector instructions."
        }
      }
    ]
  }
];



export default javaVersions;
